interface ReviewCardProps {
  avatar: string;
  name: string;
  location: string;
  title: string;
  content: string;
  rating: number;
}

export default function ReviewCard({ avatar, name, location, title, content, rating }: ReviewCardProps) {
  return (
    <div className="bg-background-50 rounded-2xl p-5 md:p-6 flex flex-col">
      <div className="flex items-center gap-1">
        {Array.from({ length: 5 }).map((_, i) => (
          <i
            key={i}
            className={`text-sm ${i < rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
          ></i>
        ))}
      </div>
      <h4 className="mt-3 text-sm md:text-base font-semibold text-foreground-900">{title}</h4>
      <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">{content}</p>
      <div className="mt-4 flex items-center gap-3 pt-3 border-t border-background-200/70">
        <img
          src={avatar}
          alt={name}
          className="w-9 h-9 rounded-full object-cover"
          loading="lazy"
        />
        <div>
          <p className="text-sm font-semibold text-foreground-900">{name}</p>
          <p className="text-xs text-foreground-500">{location}</p>
        </div>
      </div>
    </div>
  );
}